import { IconProps } from './icon-props';
import React from 'react';
import { cx } from '@mint/core';
import { kebabCase } from 'lodash';
import styled from 'styled-components';

export const makeIcon = (
  Component: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
  displayName: string,
) => {
  const Icon: React.FunctionComponent<IconProps> = (
    props,
  ): React.ReactElement => {
    return (
      <Component
        {...props}
        className={cx(kebabCase(displayName), props.className)}
      />
    );
  };

  Icon.displayName = displayName;

  return styled(Icon);
};
